import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router';
import { AppState } from '../../redux/store';
import useIsGuest from '../hook/useIsGuest';
import { ROUTES_PATH } from '../../layout/constants';

function RedirectRoute({ children }: { children: JSX.Element }) {
  const { isLogin } = useSelector((state: AppState) => state.auth);
  const isGuest = useIsGuest();
  const location = useLocation();
  if (isLogin) {
    // Khách: bản đồ chỉ còn điểm HVS nên vào đó là màn gần như trống — đưa về Dashboard,
    // tài nguyên chính của khách theo xlsx 28.07 sheet 03.
    const defaultPage = isGuest
      ? `/${ROUTES_PATH.portal.index}/${ROUTES_PATH.dashboard.index}`
      : `/${ROUTES_PATH.portal.index}/${ROUTES_PATH.menuMap.index}`;
    return <Navigate to={defaultPage} state={{ from: location }} replace />;
  }

  return children;
}

export default RedirectRoute;
